import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import Button from '../../../components/buttons/Button';
import { hasPermission } from '../../../utils/HelperFunctions';
import ExteriorInteriorColorsTableContainer from '../../../modules/exteriorInteriorColors/components/ExteriorInteriorColorsTableContainer';

const ExteriorInteriorColors = ({ interior }: { interior?: boolean }) => {
  const { t } = useTranslation();

  const type = interior ? 'interior' : 'exterior';

  const { apiData, apiDataLoading, searchEle, paginationEle } = useModuleTableHelpers({
    route: `admin/${type}-colors`,
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t(`links.${type}_colors`),
    withPagination: true,
    queryKey: `pco`,
    customSearchPlaceholder: `${t("search_by")} ${t("name")}, ${t("display_name")}, ${t("hex_code")} ${t("or")} ${t("code")}`
  });

  const tableHeaders = [
    { label: t('code') },
    { label: t('hex_code') },
    { label: t('display_name') },
    hasPermission(['colors.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="exterior-colors-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">{searchEle}</div>
        {hasPermission(['colors.edit']) && <Button text={t(`create_${type}_color`)} link={`/${type}-colors/create-${type}-color`} />}
      </ListHeader>
      <ExteriorInteriorColorsTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t(`no_${type}_colors_found`)} lessColumns interior={interior} />
      {paginationEle}
    </div>
  );
};

export default ExteriorInteriorColors;
